<template>
  <div>
    <el-popover :width="anchoPopover" trigger="click" :placement="windowWidth < 400 ? 'bottom' : 'bottom-end'"
      popper-class="popover-page" ref="carritoRef" :teleported="false" append-to=".options-right-navbar"
      v-if="(isCliente || isPartner) && is_loggin">

      <template #reference>

        <el-badge :value="cantidad" type="primary" badge-class="badge-page">
          <section class="content-reference cursor-pointer ">
            <font-awesome-icon icon="fas fa-shopping-cart" size="lg" color="white" />
            <!-- <feather-icon icon="ShoppingCartIcon" size="21" /> -->
          </section>
        </el-badge>

      </template>

      <!-- Header -->
      <li class="dropdown-menu-header">
        <div class="dropdown-header d-flex align-items-start">
          <h4 class=" mt-0 me-auto align-self-start">
            Carrito de Compras
          </h4>

          <b-badge pill variant="primary" class="d-none d-sm-block"
            style="position:absolute; top: .5rem; right: 0; margin-right: 10px;">
            <small class="text-white"> {{ cantidad > 1 ? `${cantidad} productos` : `${cantidad} producto` }} </small>
          </b-badge>

        </div>
      </li>

      <section class="content-notificacion">
        <section class="notificacion-list w-100 p-1 d-flex" v-for="(producto, i) in carrito.productos" :key="i">
          <aside class="flex-grow-0 me-1 align-self-center"
            v-if="producto.imagenes ? producto.imagenes.length ? true : false : false">
            <b-img :alt="producto.nombre" fluid class="card-img-top img-fluid" v-if="producto.thumb_img"
              :src="producto.thumb_img" style="width: 50px; height: 50px; object-fit: contain" />
          </aside>
          <main class="flex-grow-1 d-flex flex-column align-items-start  justify-content-start">
            <section>
              <strong class="fst-bolder d-block fs-3">
                {{ producto.nombre }}
              </strong>
              <small class="notification-text">
                Cantidad:{{ producto.cantidad }} {{ producto.cantidad > 1 ? 'piezas' : 'pieza' }}
              </small>
            </section>
            <b-button @click="removerProducto(producto.id)" variant="outline-danger" class="p-0"
              style="height:30px; width:50px; padding:3px;">
              <font-awesome-icon icon="fas fa-times" />
            </b-button>
          </main>
        </section>


        <section v-if="!carrito.productos.length" class="w-100 d-flex justify-content-center align-items-center h-100 ">
          <strong class="text-muted">Sin ningún producto y/o servicio agregado</strong>
        </section>

      </section>

      <li class="dropdown-footer">
        <b-button-group :vertical="windowWidth < 768 ? true : false" :class="{ 'w-100': windowWidth < 768 }"
          v-if="carrito.productos.length">
          <b-button variant="primary" title="Ir A Caja." @click="irCaja" class="d-flex flex-column align-items-center"
            style="padding-top: 5px; padding-bottom: 5px;">
            <font-awesome-icon icon="fas fa-cash-register" />
            <small class="text-nowrap">Pasar por caja</small>
          </b-button>

          <b-button variant="secondary" title="Ir a tienda" class="d-flex flex-column align-items-center "
            :to="{ name: 'tienda' }" v-if="route.name != 'tienda'" style="padding-top: 5px; padding-bottom: 5px;">
            <font-awesome-icon icon="fas fa-store" />
            <small class="text-nowrap">Seguir comprando</small>
          </b-button>


        </b-button-group>
      </li>

    </el-popover>
  </div>


</template>

<script setup>
    import { ref, onMounted, watch, toRefs, computed, onUnmounted ,inject} from 'vue';

    import useAuth from '@utils/useAuth';
    // import useCarritoCompraForm from '@composables/useCarritoCompraForm';
    import useCarritoStore from '@/store/carrito';
    import useUsuarioStore from '@/store/usuario';
    import { storeToRefs } from 'pinia';
    import useUtils from '@/composables/useUtils';
    import {useRoute,useRouter} from 'vue-router';
    const carrito_store = useCarritoStore();
    const usuario_store = useUsuarioStore();
    let { usuario,isCliente,usuario_id,isPartner } = storeToRefs(usuario_store);
    const {carrito} = storeToRefs(carrito_store);

    const carritoRef = ref(null)
    const route = useRoute();
    const router = useRouter();

    const {
      loading,
      windowWidth
    } = useUtils();
    const {
      is_loggin
    } = useAuth();

  

    let cargarForm = () => {

      if(is_loggin.value && usuario_id.value && carrito.value.id){
        
          Echo.leave(`carrito-compra.${carrito.value.id}`)
          Echo.private(`carrito-compra.${carrito.value.id}`)
            .listen('.producto-agregado', (data) => {
              const { producto, total } = data;
              carrito_store.agregarProducto(producto)
              carrito_store.setTotal(total)

            }).listen('.producto-removido', (data) => {
              const { producto_id } = data;
              if (data.producto_id) {
                carrito_store.removerProducto(producto_id)
              }
            }).listen('.compra-exitosa-limpiar-carrito', ({ carrito: cart }) => {
              if (cart) {
                carrito_store.setCarrito(cart)
              }
            });

      }
    }

    const cargarCarro = () => {
      if(!carrito.value.id){
        if (usuario_id.value) {
          carrito_store.fetchCarritoCliente(usuario_id.value)
            .then(() => {
              cargarForm();
            })
        }
      }else{
        cargarForm();
      }
    }


    onUnmounted(() => {
      Echo.leave(`carrito-compra.${carrito.value.id}`)
    })

    onMounted(() => {
      cargarCarro();

    })

    const irCaja = () => {
      carritoRef.value.hide();
      router.push({ name: 'caja' })
    }

    const anchoPopover = computed(() => {
      if (windowWidth.value < 640) {
        return 290;
      } else if (windowWidth.value < 992) {
        return 350;
      } else {
        return 420;
      }
    })


    watch([() => carrito.value.id],() => cargarForm());
    watch(usuario_id,() => cargarCarro());

    const getFecha = (fecha) => {
      return moment(fecha).format('LLL');

    }

    const cantidad = computed(() => {
      if (carrito.value.productos) {
        return carrito.value.productos.reduce((total, item) => total + item.cantidad, 0);
      }
      return 0;
    });

    const removerProducto = (product_id) => {
      preguntar({
        title:`¿Desea eliminar este producto del carrito?`,
        text: `Al eliminarlo, no podrá recuperarlo, tendrás que volver a agregarlo desde la tienda.`,
      },() => {
        carrito_store.remover(product_id)
        .then(({result}) => {
          if(result){
            toast.success("Producto eliminado del carrito correctamente.");
          }else{
            toast.error("No se pudo eliminar el producto del carrito.");
          }
        }).catch(e => {
          console.log(e);
        })
      })
    }

    const refreshCarrito = () => {
      cargarForm();
    }


</script>

<style lang="scss" scope>

.notificacion-list:hover {
  .btns {
    display: flex !important;
  }

}

.btns {
  display: none;
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 400px;
  height: 300px;
}

.content-notificacion {
  height: 300px;
  overflow-y: auto;
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
  flex-wrap: wrap;

  >div {
    flex: 1 1 auto;

    label {
      width: 100%;
    }

  }


}
</style>


